/**
 * Sticky Header
 */
(() => {
  const header = document.querySelector('header');
  const headNav = header?.querySelector('.head-nav-1');

  let scrollTimeout;
  let lastScrollTop = 0;

  window.addEventListener('scroll', () => {
    // Clear the previous timeout if the user scrolls again
    clearTimeout(scrollTimeout);
    headNav.classList.remove('show-head-nav');

    const currentScrollTop = Math.floor(window.pageYOffset);

    // Add the sticky class when scrolling down
    if (currentScrollTop > 50) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }

    // If scrolling up, show the head-nav
    if (currentScrollTop < lastScrollTop) {
      headNav.classList.add('show-head-nav');
    }

    // Update the last scroll position
    lastScrollTop = currentScrollTop;
  });
})();
